import React from "react";
import ReactDOM from "react-dom/client";
import App from "./modules/App";
import { BrowserRouter } from "react-router-dom";
import "./sass/main.scss";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
